import React, { useMemo } from 'react'
import useAlgoliaRecommend from '../../hooks/algolia/useAlgoliaRecommend'
import { ZoneIds } from '../../domain/zoneIds.ts'
import CenterCarousel from '../../components/molecules/CenterCarousel/CenterCarousel'

const MAX_SIMILAR_CENTERS_COUNT = 10

const SimilarCentersCards = ({ algoliaObjectId }) => {
  const { recommendations } = useAlgoliaRecommend(
    [algoliaObjectId],
    MAX_SIMILAR_CENTERS_COUNT
  )

  const transformedRecommendations = useMemo(
    () =>
      recommendations?.map((center) => {
        return {
          ...center,
          review_average: parseFloat(center.review_average) || null,
          review_count: parseFloat(center?.review_count) || null
        }
      }) || [],
    [recommendations]
  )

  return (
    <CenterCarousel
      centers={transformedRecommendations}
      zoneId={ZoneIds.Similar}
      isLoading={false}
      scrollItemCount={4}
      hideDescription={false}
      sectionHeading={'Similar Centers to Consider'}
      containerId="similar-centers"
      shouldHideAdTags={true}
    />
  )
}

export default SimilarCentersCards
